import React, { FC } from 'react';
import contactTypeSelect from '../../../assets/contactTypeSelect.png';
import createContactNavigation from '../../../assets/createContactNavigation.png';
import submitContact from '../../../assets/submitContact.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpBullet, HelpImage, HelpIndent, HelpStep, HelpTitle } from './HelpElements';

const CreateContactHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('createNewContactHelp');

    return (
        <>
            <HelpTitle>{t('createNewContactHelp_Title')}</HelpTitle>
            <HelpBody>{t('createNewContactHelp_purpose')}</HelpBody>
            <HelpStep step={1}>{t('createNewContactHelp_navigateToCreateContact')}</HelpStep>
            <HelpImage size={'medium'} src={createContactNavigation} />
            <HelpStep step={2}>{t('createNewContactHelp_crateContactOverview')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('createNewContactHelp_returnsType')}</HelpBullet>
                <HelpBullet>{t('createNewContactHelp_creditMemosType')}</HelpBullet>
            </HelpIndent>
            <HelpImage size={'medium'} src={contactTypeSelect} />
            <HelpStep step={3}>{t('createNewContactHelp_submit')}</HelpStep>
            <HelpImage size={'xlarge'} src={submitContact} />
        </>
    );
};

export { CreateContactHelp };
